import legalService from '../services/legal.service';
import type { LegalDocumentSummary } from '../constants/legalDocuments';

export const LEGAL_CONSENT_RESUME_KEY = 'legal_consent_resume';

/** 登录后检查是否有待确认的法律文档 */
export async function fetchPendingLegalDocuments(): Promise<LegalDocumentSummary[]> {
  try {
    const res = await legalService.getPendingDocuments();
    return res.documents || [];
  } catch {
    return [];
  }
}

export function setLegalConsentResumePath(path: string): void {
  sessionStorage.setItem(LEGAL_CONSENT_RESUME_KEY, path);
}

export function getLegalConsentResumePath(): string | null {
  return sessionStorage.getItem(LEGAL_CONSENT_RESUME_KEY);
}

export function clearLegalConsentResumePath(): void {
  sessionStorage.removeItem(LEGAL_CONSENT_RESUME_KEY);
}
